








































import Vue from 'vue';
import CustomerProp, { PropType } from '../../models/CustomerProp';
import customerClient from '../../apis';

const defaultProp: CustomerProp = {
  propName: undefined,
  fieldName: undefined,
  propType: PropType.String,
  propTypeName: undefined,
  builtIn: false,
  enumValue: undefined,
};

function copyProp(prop: CustomerProp): CustomerProp {
  return JSON.parse(JSON.stringify(prop)); 
}

const prop = copyProp(defaultProp);

export default Vue.extend({
  props: {
    edit: {
      type: Boolean,
      default: false,
    },
    outerProp: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      disabledPropType: true,
      PropType,
      prop,
    };
  },
  methods: {
    validatePropName() {
      if (!this.prop.propName ||
          this.prop.propName.trim() === '') {
        this.$Message.warning('字段名称不能为空');
        return false;
      } else {
        return true;
      }
    },
    createProp() {
      customerClient.createProp({
        propType: this.prop.propType,
        isNgram: true,
        propName: this.prop.propName,
      }).success(r => {
        this.$store.commit('ADD_CUSTOMER_PROP', r.prop);
        this.$Message.success('添加字段成功');
        this.close();
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      }).done(() => {
        this.loading = false;
      });
    },
    renameProp() {
      customerClient.renameProp({
        propField: this.prop.fieldName,
        newName: this.prop.propName,
      }).success(r => {
        this.$store.commit('RENAME_CUSTOMER_PROP', {
          fieldName: this.prop.fieldName,
          propName: this.prop.propName,
        });
        this.$Message.success('修改字段成功');
        this.close();
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      }).done(() => {
        this.loading = false;
      });
    },
    confirm() {
      if (this.validatePropName()) {
        this.loading = true;
        if (this.edit) {
          this.renameProp();
        } else {
          this.createProp();
        }
      }
    },
    close() {
      if (this.edit) {
        this.prop = copyProp(this.outerProp);
      } else {
        this.prop = copyProp(defaultProp);
      }
      this.$emit('close');
    },
  },
  mounted() {
    if (this.outerProp) {
      this.prop = copyProp(this.outerProp); 
    }
  },
});
